import {
  GET_LINEITEMS_RECORDS,
  GET_LINEITEMS_SUCCESS,
  GET_LINEITEMS_ERROR,
  UPDATE_LINEITEM_RECORD,
  UPDATE_LINEITEM_SUCCESS,
  UPDATE_LINEITEM_ERROR,
  DELETE_LINEITEM_RECORD,
  DELETE_LINEITEM_SUCCESS,
  DELETE_LINEITEM_ERROR,
  SHOW_CART_PROGRESS_RECORDS,
  UPDATE_LINE_ITEMS_STATE
} from "../actions";

const INIT_STATE = {
  loading: false,
  error: "",
  lineItems: [],
  orderId: 0,
  lineItem: null,
  progressIcon: false,
  lineItemLoading: false,
  lineItemUpdating: false,
  deleteItemLoading: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LINEITEMS_RECORDS:
      return { ...state, lineItemLoading: true, orderId: action.payload.orderId, };
    case GET_LINEITEMS_SUCCESS:
      return { ...state, lineItemLoading: false, error: "", lineItems: action.payload, progressIcon: false };
    case GET_LINEITEMS_ERROR:
      return { ...state, lineItemLoading: false, error: action.payload.message };
    case UPDATE_LINEITEM_RECORD:
      return { ...state, loading: true, lineItemUpdating: true };
    case UPDATE_LINEITEM_SUCCESS:
      let updatedLineItems = { ...(state.lineItems) };
      updatedLineItems.records = state.lineItems.records ? [...state.lineItems.records] : [];
      const indexOfLineItem = updatedLineItems.records.findIndex(li => li.lineItemId == action.payload.lineItemId);
      if (indexOfLineItem > -1) {
        updatedLineItems.records[indexOfLineItem] = action.payload;
      }
      return { ...state, loading: false, lineItemUpdating: false, error: "", lineItems: updatedLineItems, progressIcon: false };
    case UPDATE_LINEITEM_ERROR:
      return { ...state, loading: false, lineItemUpdating: false, error: action.payload.message, progressIcon: false };
    case DELETE_LINEITEM_RECORD:
      return { ...state, loading: true, deleteItemLoading: true, lineItem: action.payload.lineItem };
    case DELETE_LINEITEM_SUCCESS:
      let updatedLineItemsOnDelete = { ...(state.lineItems) };
      updatedLineItemsOnDelete.records = state.lineItems.records ? [...state.lineItems.records] : [];
      updatedLineItemsOnDelete.records = updatedLineItemsOnDelete.records.filter(li => li.lineItemId != action.payload.lineItemId);
      return { ...state, loading: false, deleteItemLoading: false, error: "", lineItems: updatedLineItemsOnDelete, progressIcon: false };
    case DELETE_LINEITEM_ERROR:
      return { ...state, loading: false, deleteItemLoading: false, error: action.payload.message, progressIcon: false };
    case SHOW_CART_PROGRESS_RECORDS:
      return { ...state, progressIcon: action.payload.progressIcon };
    case UPDATE_LINE_ITEMS_STATE:
      return { ...state, ...action.payload };
    default:
      return { ...state };
  }
};
